import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { totalTimeWatchedConfig } from '@/lib/analytics/kpis/youtube/totalTimeWatched';
import { SIZE_50 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerVideoViewsTotalTimeConfig: KpiType<
    typeof MediaViewerKpiLoader,
    typeof KPIDefault
> = {
    ...totalTimeWatchedConfig,
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
